(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  $(document).ready(function(){
    $(".site-nav--is-megamenu .h5").mouseover(function(){
      $(".cstm-side-image .hover-image img").attr("src",$(this).find(".site-nav__dropdown-link").attr("coll-img"));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
